<template>
  <div class="d-flex flex-column h-100">
    <v-card-text class="flex-grow-1 d-flex flex-column">
      <v-card class="media-card flex-grow-1 d-flex flex-column" flat>
        <v-card-title>
          <span>{{ title }}</span>
        </v-card-title>
        <v-card-text class="flex-grow-1 d-flex flex-column">
          <div class="flex-grow-1">
            <slot name="description" />
          </div>
          <v-text-field v-model="localValue" :disabled="disabled" outlined hide-details :label="title" class="mt-4" @input="$emit('input', localValue)" />
        </v-card-text>
      </v-card>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'GenericConfigurationCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localValue: '',
  }),
  watch: {
    value: {
      handler(newVal) {
        this.localValue = newVal
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
$background-card-color: $cinza-l90;
.media-card {
  background-color: $background-card-color;
}
</style>
